<template>
  <div class='pcVote' >
    <el-container>
      <el-header height="" style="padding:0px">
          <div v-cloak>
            <a :href="jumpUrl || '#'"  :target="jumpUrl? '_blank': ''">
              <img style="width:100%;" :src="defaultHeaderImg" alt="">
            </a> 
          </div>
      </el-header>
      <el-container>
        <el-aside width="100%">
          <p class="title">{{title}}</p>
          <p class="description" v-html="rules"></p>
          <div class="qrcode">
            <figure>
              <img
              :src="qrcode1"
              alt="A robotic monster over the letters MDN.">	
              <figcaption>丝路视听APP下载</figcaption>
            </figure>
            <figure>
              <img
              :src="qrcode2"
              alt="A robotic monster over the letters MDN.">	
              <figcaption>关注直播新疆微信</figcaption>
            </figure>
            <figure>
              <img
              :src="qrcode3"
              alt="A robotic monster over the letters MDN.">	
              <figcaption>关注丝路视听微信</figcaption>
            </figure>
          </div>
          <div class="list">
            <ul>
              <li v-for='(item, index) in figureData' :key="index">
                <div class="detailMsg">
                  <div class="img">
                    <img :src="item.cover" alt="">
                    <span>{{index>8? (index + 1) : '0'+(index+1)}}</span>
                  </div>
                  <div class="action">
                    <div :data-id="item.id">
                      <el-button :data-id="item.id" @click="voteBtn($event)"></el-button>
                    </div>
                    <span><span>{{votes[item.id] || votes[index] || 0}}</span>票</span>
                  </div>
                </div>
                <div class="detail_description">
                  <p class="name">姓名：{{item.name}}</p>
                  <p class="column">栏目：{{item.description}}</p>
                  <div class="motto">
                    <!-- <p class="left">人生格言：</p>
                    <template class="span_left" v-html="item.content"></template> -->
                    人生格言：<span class="span_left" v-html="item.content"></span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="footer">
            <p>新疆广播电视台</p>
            <p>中国新疆广播电视台版权所有 Copyright 2004-2008，ALL Rights Reserved 新ICP备10200192号 信息网络传播视听节目许可证号 3105132</p>
            <p>新公网安备 65010202001065号  </p>
          </div>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import moment from 'moment';
import axios from "axios";
import $ from 'jquery';
import defaultHeaderImg from "../assets/header.png";
import qrcode1 from "../assets/qrcode1.png";
import qrcode2 from "../assets/qrcode2.png";
import qrcode3 from "../assets/qrcode3.png";

export default {
  name: "pcVote",
  data() {
    return {
      figureData: [],
      votes: {},
      voteLoading: false,
      detailDialogVisible: false,
      moreActivityIntroduce: false,
      detailData: {},
      rules: null,
      id: null,
      headerImgUrl: '',
      defaultHeaderImg: defaultHeaderImg,
      vote_id: null,
      nowDate: null,
      jumpUrl: null,
      dialogWidth: '60%',
      dialogFullscreen: false,
      allPlayerNum: 0, // 投票总人数
      allVoteSum: 0, // 总投票数
      start_time: 0, // 投票起止时间
      now: moment(), // 现在时间
      end_time: '',
      seachValue: '',
      tableLoading: true,
      voteRank: 1,
      getTimeInt: null,
      qrcode1: qrcode1,
      qrcode2: qrcode2,
      qrcode3: qrcode3,
      title: ''
    };
  },
  methods: {
    detail: async function(e) {
      if (e) e.preventDefault();
      let id = null;
      id = e.target.parentNode.getAttribute("data-id");
      if (!id) {
        id = e.target.parentNode.parentNode.getAttribute("data-id");
      }
      if (id) {
        this.id = id;
        const resData = await axios.get(
          `/lua/api/vote/item?vote_id=${this.vote_id}&id=${id}`
        );
        this.detailData = resData.data.data.item;
        this.detailDialogVisible = true;
      }
    },
    /*
     * 获取?后面的参数并返回 json 对象
     */
     GetRequest(url) {
        if (!url || url.indexOf('?') == -1) {
            return {};
        }
        var url = url.split('?')[1].split('#')[0]; //获取url中"?"符后"#"前的字串
        var theRequest = new Object();
        var str = decodeURI(url);
        var strs;
        if (str.indexOf("&") != -1) {
            strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        } else {
            theRequest[str.split("=")[0]] = unescape(str.split("=")[1]);
        }
        theRequest['vote_id'] = theRequest['act_id'];

        return theRequest;
    },
    voteBtn: async function(e) {
      console.log(e);
      if (e) e.preventDefault();
      let _this = this;
      let id = null;
      id = e.target.parentNode.getAttribute("data-id");
      console.log(id);
      if (!id) {
        id = e.target.parentNode.parentNode.getAttribute("data-id");
      }
      if (id) {
        const loading = this.$loading({
          lock: true,
          text: "投票中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)"
        });
        let urlData = this.changeURLArg(location.href, "OpenID", this.nowDate);
        let newUrlData = this.changeURLArg(urlData, "uid", this.nowDate);
        const nowUrl = newUrlData
          .slice(newUrlData.indexOf("?"))
          .replace("#", "");
        const vote_token = await axios.get(`/api/app/sign/mf.php${nowUrl}`);
        const resData = await axios.get(
          `/lua/api/vote/vote${nowUrl}&item_id=${id}&vote_token=${
            vote_token.data.vote_token
          }&vote_id=${this.vote_id}`
        );
        if (resData.data.code === 200) {
          this.detailDialogVisible = false;
          setTimeout(() => {
            loading.close();
            this.$message({
              message: "投票成功",
              type: "success",
              duration: "1000"
            });
          }, 1500);
          if (this.voteRank === 1) {
            axios
            .get(`/lua/api/vote/details?&vote_id=${this.vote_id}&id=${id}`)
            .then(res => {
              this.allVoteSum = 0;
              this.allPlayerNum = res.data.data.details.items.length || 0;
              _this.figureData = [...res.data.data.details.items];
              _this.votes = { ...res.data.data.votes };
              for( let k in res.data.data.votes) {
                this.allVoteSum += res.data.data.votes[k];
              };
            });
          } else {
            axios.get(`/lua/api/vote/rank?vote_id=${this.vote_id}`).then(res => {
              this.allVoteSum = 0;
              this.figureData = [...res.data.items];
              this.votes = { ...res.data.scores };
              for( let k in res.data.scores) {
                this.allVoteSum += res.data.scores[k];
              };
            
            });
          }
          
        } else {
          loading.close();
          this.$message({
            message: resData.data.message,
            type: "error"
          });
        }
      }
    },
    changeURLArg: function(url, arg, arg_val) {
      var pattern = arg + "=([^&]*)";
      var replaceText = arg + "=" + arg_val;
      if (url.match(pattern)) {
        var tmp = "/(" + arg + "=)([^&]*)/gi";
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
      } else {
        if (url.match("[?]")) {
          return url + "&" + replaceText;
        } else {
          return url + "?" + replaceText;
        }
      }
      return url + "\n" + arg + "\n" + arg_val;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    moreActivityIntroduceBtn() {
      this.moreActivityIntroduce = true;
    },
    getQueryString: function(name) {
      var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      console.log(window.location);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    headerImgClick() {
      window.location.href = 'https://www.baidu.com/'
    },
    searchHandle() {
      console.log(this.seachValue);
      const _this = this;
      this.tableLoading = true;
      if (this.seachValue && this.seachValue.length > 0) {
         axios.get(`/api/vote/${_this.vote_id}/search?q=${_this.seachValue}`).then(res => {
          if (res && res.status === 200) {
            axios.post(`/lua/api/vote/search`, {
              act_id: _this.vote_id,
              ids: res.data.data['ids']
            }).then(response => {
              if (response.status === 200 && response.data.code === 200) {
                _this.figureData = [...response.data.data.items];
                _this.votes = { ...response.data.data.scores };
              } else {
                _this.figureData = [];
                _this.votes = {};
              } 
              this.tableLoading = false;
            })
          }
        });
      } else {
      this.voteRank = 1;
         axios
      .get(`/lua/api/vote/details?vote_id=${this.vote_id}`)
      .then(res => {
        if (res.status === 200) {
          this.figureData = [...res.data.data.details.items];
          this.votes = { ...res.data.data.votes };
          this.tableLoading = false;
        }
      })
      }
     
    },
    defaultRank() {
      this.seachValue = '';
      this.voteRank = 1;
       axios.get(`/lua/api/vote/details?vote_id=${this.vote_id}`).then(res => {
        this.figureData = [...res.data.data.details.items];
        this.votes = { ...res.data.data.votes };

        const num = res.data.data.details.title.indexOf('||'); // 标题和跳转地址以||分割
        let title = res.data.data.details.title.slice(0, num || null);
        let activities = res.data.data.details;
        window.parameter = this.GetRequest(window.location.href);
        let isWechat = (window.parameter.ways == 'wechat');//是否开启微信
        let isAPP = (activities.publishing.app.is_open =='on');//是否开启APP
        let isFollow = (window.parameter['following']!=1);//是否关注
        let isCode = Boolean(activities.publishing.wechat.qr_code[0]);//是否上传二维码
        let isPart = false;
        if(isWechat){
            if(isFollow){
                isPart = true;
            }else{
                if(isCode){
                    var qrCode = QRCode(activities.publishing.wechat.qr_code[0]).open();
                }else{
                    isPart = true;
                }
            }
        }else{
            //APP
        }
        if (typeof wxshare != 'undefined' && (activities.shares.isopen == 'on' || activities.shares.isopen == '1')) {
            var shareLink = '';
            if(isWechat){
                shareLink =window.location.origin+'/wechat/shares?id='+window.parameter.act_id;
            }else{
                shareLink = window.location.origin + location.pathname + '?from=singlemessage&act_id=' + wxshare.getUrlParam('act_id');
            }
            wxshare.share({
                title: activities.shares.title || title,
                desc: activities.shares.content || '快来参加投票吧！',
                link: shareLink,
                imgUrl: activities.shares.thumb || 'http://wjtest-yanfa-cos-1257137142.cos.ap-beijing.myqcloud.com/tmp/20190729/19/20190729190357564182.png',
            });
        }else{
            // forbidShare();
        }





      });
    },
    rank() {
      this.seachValue = '';
      this.voteRank = 0;
       axios.get(`/lua/api/vote/rank?vote_id=${this.vote_id}`).then(res => {
        this.figureData = [...res.data.items];
        this.votes = { ...res.data.scores };
       
      });
    },
     //数字前补 0 
	  // num传入的数字，n需要的字符长度
    PrefixInteger(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },
     getRank(key){
      if (!Array.isArray(this.votes)) {
        const arr = Object.keys(this.votes);
        for ( let k in arr) {
          if (arr[k] === key) {
            return (~~k + 1);
          }
        }
      }
    }
  },
  created() {
    
    if (document.body.clientWidth < 992) {
      this.dialogFullscreen = true;
    }
    this.vote_id = this.getQueryString("act_id");
    this.nowDate = Date.parse(new Date());
    axios
      .get(`/lua/api/vote/details?vote_id=${this.vote_id}`)
      .then(res => {
        if (res.status === 200) {
          this.allPlayerNum = res.data.data.details.items.length || 0;
          this.figureData = [...res.data.data.details.items];
          this.votes = { ...res.data.data.votes };
          this.rules = res.data.data.details.rules;
          this.headerImgUrl = res.data.data.details.background_img || this.defaultHeaderImg || 'http://wjtest-yanfa-cos-1257137142.cos.ap-beijing.myqcloud.com/20190618/10/20190618104830978310.jpg';
          const num = res.data.data.details.title.indexOf('||'); // 标题和跳转地址以||分割
          document.title = res.data.data.details.title;
          this.jumpUrl = (num !== -1 ? res.data.data.details.title.slice(num+2) : null);
          for( let k in res.data.data.votes) {
            this.allVoteSum += res.data.data.votes[k];
          };
          // 起止时间
          this.end_time = res.data.data.details.end_time;
          this.start_time = res.data.data.details.start_time;
          this.tableLoading = false;
          // console.log(Object.keys(this.votes));

          this.title = res.data.data.details.title;          
          let title = res.data.data.details.title.slice(0, num || null);
          let activities = res.data.data.details;
          window.parameter = this.GetRequest(window.location.href);
          let isWechat = (window.parameter.ways == 'wechat');//是否开启微信
          let isAPP = (activities.publishing.app.is_open =='on');//是否开启APP
          let isFollow = (window.parameter['following']!=1);//是否关注
          let isCode = Boolean(activities.publishing.wechat.qr_code[0]);//是否上传二维码
          let isPart = false;
          if(isWechat){
              if(isFollow){
                  isPart = true;
              }else{
                  if(isCode){
                      var qrCode = QRCode(activities.publishing.wechat.qr_code[0]).open();
                  }else{
                      isPart = true;
                  }
              }
          }
          var shareLink = '';
          if(isWechat){
              shareLink =window.location.origin+'/wechat/shares?id='+window.parameter.act_id;
          }else{
              shareLink = window.location.origin + location.pathname + '?from=singlemessage&act_id=' + wxshare.getUrlParam('act_id');
          }
          // console.log('¥', $);
          // console.log('title', window.location.href.slice(0, -1));
          wxshare.share({
              title: activities.shares.title || title,
              desc: activities.shares.content || '快来参加投票吧！',
              link: window.location.href.slice(0, window.location.href.indexOf('#/')),
              imgUrl: activities.shares.thumb || 'http://wjtest-yanfa-cos-1257137142.cos.ap-beijing.myqcloud.com/tmp/20190729/19/20190729190357564182.png',
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  mounted() {
   
  },
  computed: {
	  //计算属性，返回剩余时间
	  countDown(){
	    return function(endDate) {
	      let m1 = this.now;
	      let m2 = moment(endDate);
        let du = moment.duration(m2 - m1, 'ms');
        let years = du.get('years');
        let months = du.get('months');
        let days = du.get('day');
        let hours = du.get('hours');
        let mins = du.get('minutes');
        let ss = du.get('seconds');
        days +=  (months * 30 + years * 365);
        // console.log(days);
        if (days >= 99) {
          days = 99;
        };
	      if(days<=0&&hours<=0 && mins<=0 && ss<=0) {
	        return "00000000000000"
	      }else {
	        return this.PrefixInteger(days,2) + this.PrefixInteger(hours,2) + this.PrefixInteger(mins,2) + this.PrefixInteger(ss,2)
	      }
	    }
    },
   
	},
  beforeDestroy() {
  },
  updated() {
    $('.span_left').find('p').css('display', 'inline');
    $('.span_left').find('div').css('display', 'inline');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[v-cloak] {
  display: none !important;
}

@media (min-width: 1200px) {
  .pcVote {
    /* width: 75%; */
    margin: 0 auto;
    /* height: 80%; */
    text-align: center;
    background-color: #403594;
    
  }
  .pcVote header {
    max-height: 600px;
    /* background: red; */
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    padding: 0 !important;
  }
}

.pcVote .span_left>p {
  /* float: left; */
  display: inline!important;
}

.pcVote aside {
  padding: 0 50px;
}
.pcVote .title {
  margin: 10px;
  font-size:33px;
  font-family:DFPShaoNvW5;
  font-weight:400;
  color:rgba(255,234,0,1);
  line-height:45px;
}
.pcVote .description {
  text-indent:2em;
  padding: 0 100px;
  font-size:22px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:31px;
  text-align-last: left;
  text-align: justify;
}
.pcVote .qrcode img {
  width: 210px;
  height: 210px;
}
.pcVote .qrcode {
  margin: 30px auto;
  display: flex;
  justify-content: space-around;
  width: 700px;
}
.pcVote .qrcode figcaption {
  font-size:22px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
  margin-top: 10px;
}
.pcVote .list ul {
  width: 1200px;
  /* clear: both; */
  margin: 50px auto;
  overflow: hidden;
}
.pcVote .list li {
  width: 276px;
  min-height: 640px;
  margin-right: 30px;
  margin-bottom: 20px;
  float: left;
  list-style: none;
  box-sizing: border-box;
}
.pcVote .list li:nth-of-type(4n) {
  margin-right: 0
}
.pcVote .list li .detailMsg {
  width: 100%;
  height: 420px;
  background: white;
  padding-top: 20px;
  padding: 20px 18px;
  box-sizing: border-box;
}
.pcVote .list li .detailMsg .img {
  width: 240px;
  height: 320px;
  background:rgba(201,201,201,1);
  position: relative;
}
.pcVote .list li .detailMsg .img span{
  position: absolute;
  top: 0;
  left: 0;
  width: 77px;
  height: 52px;
  background: #E60012;
  line-height: 52px;
  text-align: center;
  font-size: 32px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
}
.pcVote .list li .detailMsg img {
  width: 100%;
  height: 100%;
}
.pcVote .list li .detailMsg .action {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.pcVote .list li .detailMsg .action div {
  width: 102px;
  height: 52px;
  background-image:url('../assets/vote.png');
  cursor: pointer; 
}
.pcVote .list li .detailMsg .action div button {
 opacity: 0;
 width: 100%;
 height: 100%;
}
.pcVote .list li .detailMsg .action span {
  font-size:22px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height: 52px;
}
.pcVote .list li .detail_description {
  padding: 10px 18px;
  text-align: left;
  font-size:20px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
}
.pcVote .list li .detail_description .name {
  /* margin: 7px 0; */
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.pcVote .list li .detail_description .column {
  height: 50px;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.pcVote .list li .detail_description .motto {
  text-align-last: left;
  text-align: justify;
  overflow:hidden;
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:4;
  /*!autoprefixer:off*/
  -webkit-box-orient: vertical;
  /*autoprefixer:on*/
}
.pcVote .footer {
  margin: 50px;
  font-size:18px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
}
</style>



// WEBPACK FOOTER //
// src/components/pcVote.vue